import {remote} from '../constants/environment';
import {IResponse} from '../interfaces/services/response.interface';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

export const postSignIn = async (
  email: string,
  password: string,
): Promise<IResponse> => {
  const remoteURI = remote.getLoginUri();
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'POST',
        headers: defaultHeaders,
        body: JSON.stringify({
          payload: {
            email,
            password,
          },
        }),
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = (await response.json()) as IResponse;

        if (data.success && data.payload && data.payload.session) {
          const success = true;
          const begin = Date().toString();
          const lifetime = '24h';

          const {
            session,
            banks,
            profile,
            entities,
            phone,
            faq,
            uiMobile,
            whatsapp,
            salesman,
            sourceBanks,
          } = data.payload;

          return {
            success: true,
            payload: {
              email,
              success,
              credentials: {
                ...session,
                begin,
                lifetime,
              },
              profile,
              banks,
              sourceBanks,
              entities,
              phone,
              whatsapp,
              faq,
              uiMobile: {
                proofForm: uiMobile.proofForm,
                geoLocation: uiMobile.geoLocation,
              },
              salesman,
            },
          };
        } else {
          return {
            success: false,
            payload: {
              success: false,
              credentials: null,
            },
            error: data.error,
          };
        }
      }
    },
    remoteURI,
  )) as IResponse;
};
